import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { columnsDataComplex } from "./variables/columnsData";
import { getAllAccounts } from "../../../redux/action/index";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import AccountsTable from "./AccountsTable";
import { getCookie } from "utils/cookie";
import { ConvertDateToEpoch } from "utils/functions";
const AccountsList = (props) => {
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const [usersData, setUsersData] = useState([]);
  const [shimmer, setShimmer] = useState(false);
  let [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const [search, setSearch] = useState("");
  const [sort, setSort] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [status, setStatus] = useState("");

  const toggleDrawer = (open) => {
    setIsDrawerOpen(open);
  };
  const handleGetAccounts = (page) => {
    setShimmer(true);
    dispatch(
      getAllAccounts({
        skip: (page - 1) * 10,
        limit: 10,
        role:
          getCookie("role") === "super-admin"
            ? "superadmin"
            : getCookie("role"),
        search: search,
        startDate: ConvertDateToEpoch(startDate),
        endDate: ConvertDateToEpoch(endDate),
        sort: parseInt(sort),
        status: parseInt(status),
      })
    )
      .then((res) => {
        setUsersData(res.data);
        setShimmer(false);
      })
      .catch((err) => {
        setUsersData([]);
        console.log("Get Err:", err);
        setShimmer(false);
      });
  };
  useEffect(() => {
    handleGetAccounts(page);
  }, [page]);
  const resetFilters = () => {
    setStatus("");
    setSearch("");
    setSort("");
    setStartDate("");
    setEndDate("");

    setShimmer(true);
    dispatch(
      getAllAccounts({
        skip: (page - 1) * 10,
        limit: 10,
        role:
          getCookie("role") === "super-admin"
            ? "superadmin"
            : getCookie("role"),
      })
    )
      .then((res) => {
        setUsersData(res.data);
        setShimmer(false);
      })
      .catch((err) => {
        console.log("Get Err:", err);
        setShimmer(false);
      });
  };
  return (
    <>
      <AccountsTable
        columnsData={columnsDataComplex}
        tableData={[]}
        handleGetAccounts={handleGetAccounts}
        usersData={usersData}
        shimmer={shimmer}
        search={search}
        setSearch={setSearch}
        sort={sort}
        setSort={setSort}
        status={status}
        setStatus={setStatus}
        startDate={startDate}
        setStartDate={setStartDate}
        endDate={endDate}
        setEndDate={setEndDate}
        isDrawerOpen={isDrawerOpen}
        setIsDrawerOpen={setIsDrawerOpen}
        toggleDrawer={toggleDrawer}
        resetFilters={resetFilters}
      />
      {usersData?.count > 10 && (
        <div className="flex h-[50px] w-full items-center justify-center">
          <Stack spacing={2}>
            <Pagination
              count={Math.ceil(usersData?.count / 10) || 10}
              page={page}
              onChange={(e, page) => setPage(page)}
              variant="outlined"
              color="primary"
            />
          </Stack>
        </div>
      )}
    </>
  );
};

export default AccountsList;
